(function () {
    'use strict';

    angular
        .module('core.services')
        .service('UserService', UserService)

    /** @ngInject */
    function UserService(HttpService) {
        const UserService = {
            getPreRegister: getPreRegister,
            firstAccess: firstAccess,
            createPreRegister: createPreRegister
        }

        return UserService;

        function getPreRegister(cpf) {
            return HttpService.get(`/users/pre-register/${cpf}`);
        }

        function firstAccess(userData) {
            return HttpService.post('/users/first-access', userData);
        }

        function createPreRegister(preRegisterData) {
            return HttpService.post('/pre-registers', preRegisterData);
        }
    }
}());